import React from 'react';

const Layout = ({ children }) => {
  return (
    <div className="page-wrapper">
      {children}
      <div className="mobile-nav__wrapper">
        <div className="mobile-nav__overlay mobile-nav__toggler"></div>
        <div className="mobile-nav__content">
          <span className="mobile-nav__close mobile-nav__toggler"><i className="fa fa-times"></i></span>
          <div className="logo-box">
            <a href="index.html" aria-label="logo image"><img src="assets/images/c2_logo_yt.png" width="155" alt="C2 Community Logo" /></a>
          </div>
          <div className="mobile-nav__container"></div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope"></i>
              <a href="mailto:createncommune@gmail.com">createncommune@gmail.com</a>
            </li>
            <li>
              <i className="fa fa-phone-alt"></i>
              <a href="tel:666-888-0000">666 888 0000</a>
            </li>
          </ul>
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <a href="https://x.com/CreateNCommune" target="_blank" rel="noopener noreferrer" className="fab fa-twitter"><span></span></a>
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="fab fa-facebook-square"><span></span></a>
              <a href="https://www.tiktok.com/@createncommune?is_from_webapp=1" target="_blank" rel="noopener noreferrer" className="fab fa-tiktok"><span></span></a>
              <a href="https://www.instagram.com/createncommune/" target="_blank" rel="noopener noreferrer" className="fab fa-instagram"><span></span></a>
            </div>
          </div>
        </div>
      </div>
      <div className="search-popup">
        <div className="search-popup__overlay search-toggler"></div>
        <div className="search-popup__content">
          <form action="#">
            <label htmlFor="search" className="sr-only">search here</label>
            <input type="text" id="search" placeholder="Search Here..." />
            <button type="submit" aria-label="search submit" className="thm-btn">
              <i className="icon-magnifying-glass"></i>
            </button>
          </form>
        </div>
      </div>
      <a href="#!" data-target="html" className="scroll-to-target scroll-to-top"><i className="fa fa-angle-up"></i></a>
    </div>
  );
};

export default Layout;
